import React from 'react';
import SecurityContent from '../components/SecurityContent/SecurityContent';
import CtaSection from '../components/CtaSection/CtaSection';

const SapSecurityPage = () => {
  return (
    <>
      <SecurityContent />
      <CtaSection />
    </>
  );
};

export default SapSecurityPage;
